import { useSelector } from 'react-redux';
import {
  ackSelector, alarmCenterSelector, currentPositionSelector,
} from 'features/details';
import { connectedCustomerSelector } from 'features/identity';
import { userContextSelector } from 'features/identity/auth';

/**
 * Whether the building lookup applies to this alarm. Places is billed per lookup and the server only allows it for the
 * alarm center of this alarm (and global admins, whatever customer is connected).
 */
export const useCanLookupBuilding = (): boolean => {

  const position = useSelector(currentPositionSelector);
  const closed = useSelector(ackSelector);
  const alarmCenter = useSelector(alarmCenterSelector);
  const customer = useSelector(connectedCustomerSelector);
  const isAdmin = !!useSelector(userContextSelector)?.user?.globalRoles?.includes('admin');

  return !closed && (isAdmin || (!!alarmCenter && alarmCenter._id === customer?._id))
    && position?.properties?.address?.countryCode?.toUpperCase() !== 'BE';

};
